/**
 * Reine Mapping-Funktion: Feld-Rezepte (API) -> RecipeDefault je (Channel,
 * Texttyp), fuer den Wizard-Prefill in CreateRunSection (Spec 2026-08-15 §4.2).
 */

import type { BulkAttributeCode } from '@/lib/api/channel-content-bulk'
import type { ChannelFieldRecipe } from '@/lib/api/channel-content-bulk-types'

import type { RecipeDefault } from './useFieldSelections'

export function buildRecipeDefaultsByChannel(
  fieldRecipes: ChannelFieldRecipe[],
): Record<string, Partial<Record<BulkAttributeCode, RecipeDefault>>> {
  const map: Record<string, Partial<Record<BulkAttributeCode, RecipeDefault>>> = {}
  for (const r of fieldRecipes) {
    map[r.channel_id] ??= {}
    map[r.channel_id][r.attribute_code] = {
      templateId: r.template_id ?? null,
      systemToolCode: r.settings.system_tool_code ?? null,
    }
  }
  return map
}
